import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

import { formatCurrency } from "../../../../../../../util";

const RefundReceiptWarning = ({ currencyCode, refundableReceiptAmount }) => {
  const hasRefundableReceiptCredit = refundableReceiptAmount > 0;

  return (
    <div
      className="flex items-start gap-3 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900"
      role="status"
    >
      <ExclamationTriangleIcon
        className="mt-0.5 h-5 w-5 shrink-0"
        aria-hidden="true"
      />
      <div>
        <div className="font-semibold">Refund receipt credit</div>
        {hasRefundableReceiptCredit ? (
          <div>
            Up to {formatCurrency(refundableReceiptAmount, currencyCode)} can be
            refunded before creating the Credit Note. Refunds cannot exceed the
            unrefunded receipt value on this invoice.
          </div>
        ) : (
          <div>
            No receipt value is available to refund. Add or restore a receipt
            before issuing a refund.
          </div>
        )}
      </div>
    </div>
  );
};

export default RefundReceiptWarning;
